export default {"src":"/_next/static/media/brown-map.b8a775f0.svg","height":48,"width":49,"blurWidth":0,"blurHeight":0};